export const getLoanAmount = (report) => {
    let data = null;
    if (report && report.emiReport) {
        data = report.emiReport.loanAmount;
    }
    return data;
}

export const getTenure = (report) => {
    let data = null;
    if (report && report.emiReport) {
        data = report.emiReport.tenureInYears;
    }
    return data;
}

export const getRateOfInterest = (report) => {
    let data = null;
    if (report && report.emiReport) {
        data = report.emiReport.annualInterestRate;
    }
    return data;
}

export const getEMI = (report) => {
    let data = null;
    if (report && report.emiReport) {
        data = report.emiReport.monthlyEMI;
    }
    return data;
}

export const getInterestPayable = (report) => {
    let data = null;
    if (report && report.emiReport) {
        data = report.emiReport.interestPayable;
    }
    return data;
}

export const getInterestPercentage = (report) => {
    let data = null;
    if (report && report.emiReport) {
        data = report.emiReport.interestPercentage;
    }
    return data;
}

export const getTotalAmountPayable = (report) => {
    let data = null;
    if (report && report.emiReport) {
        data = report.emiReport.totalAmountPayable;
    }
    return data;
}

export const createLoanPieChartData = (reports) => {
    let pieChartData = [];
    if (reports && reports.emiReport) {
        const interestPayablePercentage = Math.round((reports.emiReport.interestPayable / reports.emiReport.totalAmountPayable) * 100);
        const loanAmountPercentage = Math.round((reports.emiReport.loanAmount / reports.emiReport.totalAmountPayable) * 100);

        pieChartData.push({
            id: Math.random(),
            value: loanAmountPercentage,
            label: 'Principal Amount'
        });
        pieChartData.push({
            id: Math.random(),
            value: interestPayablePercentage,
            label: 'Total Interest'
        });

    }
    return pieChartData;

}


export const getCorpus = (report) => {
    let data = null;
    if (report && report.lumpsumReport) {
        data = report.lumpsumReport.totalValue;
    }
    return data;
}

export const getProfitAmount = (report) => {
    let data = null;
    if (report && report.lumpsumReport) {
        data = report.lumpsumReport.profit;
    }
    return data;
}

export const getProfitPercentage = (report) => {
    let data = null;
    if (report && report.lumpsumReport) {
        data = report.lumpsumReport.profitPercentage;
    }
    return data;
}

export const getPercentageOfSavingsOnInterest = (report) => {
    let percentageOfTotalSavingsOnInterest = null;
    if (report && report.percentageOfTotalSavingsOnInterest) {
        percentageOfTotalSavingsOnInterest = report.percentageOfTotalSavingsOnInterest + '%';
    }
    return percentageOfTotalSavingsOnInterest;
}
export const getAmountOfSavingsOnInterest = (report) => {
    let totalSavingsOnInterest = null;
    if (report && report.totalSavingsOnInterest) {
        totalSavingsOnInterest = report.totalSavingsOnInterest;
    }
    return totalSavingsOnInterest;
}

export const graphXAxis = [
    {
        id: 'Years',
        dataKey: 'tenureInYears',
        scaleType: 'number'
    },
];

export const graphSeries = [
    {
        id: 'Invested',
        label: 'Invested',
        dataKey: 'investedAmount',
        stack: 'total',
        area: true,
        showMark: false,
    },
    {
        id: 'Profit',
        label: 'Profit',
        dataKey: 'profit',
        stack: 'total',
        area: true,
        showMark: false,
    },
    {
        id: 'Corpus',
        label: 'Corpus',
        dataKey: 'totalValue',
        stack: 'total',
        area: true,
        showMark: false,
    },
];
